import React, { useState, useEffect } from "react";
import SliderPagination from "./SliderPagination";
import "../../pages/consultation/consultation.css";
import { getConsultationBlogs } from "../../axios";
import { SwiperSlide } from "swiper/react";
import AOS from "aos";

const BlogNews = () => {
  const [blogsData, setBlogsData] = useState([]);

  //getting blogs(news) data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getConsultationBlogs();
        if (data) setBlogsData(data.reverse().slice(0,11));
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchData();
  }, []);

  //initializing aos animations
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);

  return (
    <section id="recent_news" class="recent-news">
      <div class="container">
        <div class="row">
          <div class="text-center col-12 section-title" data-aos="fade-zoom-in">
            <h3 className="main-title">
              <span> اخبار</span> جدید
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="recent-news-slider" data-aos="fade-up">
              <SliderPagination space={30} slidesPerGroup={1}>
                {blogsData?.map((item) => (
                  <SwiperSlide
                    key={item.id}
                    slidesPerView={1}
                    slidesPerGroup={1}
                  >
                    <div class="item">
                      <div class="row align-items-center"><div class="col-md-6 col-12 d-flex flex-column gap-4">
                          <h3>{item.title}</h3>
                          <p>
                            {item.text.length > 200
                              ? item.text.substring(0, 200) + "..."
                              : item.text}
                          </p>
                          <ul class="news-meta">
                            <li>
                              <span class="lnr lnr-user"></span> توسط مدیر
                            </li>
                          </ul>
                          <a
                            target="_blank"
                            href={`/blog/${item.title}`}
                            class="readMore-btn"
                          >
                            <span>بیشتر بخوانید</span>
                          </a>
                        </div>
                        <div class="col-md-6 col-12">
                          <img src={item.img} class="img-fluid" alt="" />
                        </div>
                        
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </SliderPagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogNews;
